import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    getProfessionalQualificationRequest: ['response'],
    getProfessionalQualificationSuccess: ['response', 'loading'],
    getProfessionalQualificationFailure: ['error'],
})

export const getProfessionalQualificationTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */

const getProfessionalQualificationSuccess = (state, { response }) =>
    state.merge({
        error: false,
        response,
        loading: false,
    })
const getProfessionalQualificationFailure = (state, { error }) =>
    state.merge({
        loading: false,
        error,
    })
const getProfessionalQualificationRequest = state =>
    state.merge({ loading: true, error: null })

export const reducer = createReducer(INITIAL_STATE, {
    [Types.GET_PROFESSIONAL_QUALIFICATION_REQUEST]: getProfessionalQualificationRequest,
    [Types.GET_PROFESSIONAL_QUALIFICATION_SUCCESS]: getProfessionalQualificationSuccess,
    [Types.GET_PROFESSIONAL_QUALIFICATION_FAILURE]: getProfessionalQualificationFailure,
})
